// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3yasF","info":"UpdateTermsInfo_info__yCV6U"};